export interface LanguageOption {
  value: string
  label: string
}

// Base language options available in all environments
const BASE_LANGUAGE_OPTIONS: LanguageOption[] = [
  {
    value: 'id',
    label: 'Bahasa Indonesia',
  },
  {
    value: 'ms',
    label: 'Bahasa Melayu',
  },
  {
    value: 'en',
    label: 'English (United States)',
  },
  {
    value: 'en-GB',
    label: 'English (United Kingdom)',
  },
  {
    value: 'es',
    label: 'Español',
  },
  {
    value: 'es-MX',
    label: 'Español - Mexico',
  },
  {
    value: 'pt-pt',
    label: 'Português - Portugal',
  },
  {
    value: 'tr',
    label: 'Türkçe',
  },
]

// Vietnamese language option (staging only)
const VIETNAMESE_OPTION: LanguageOption = {
  value: 'vi',
  label: 'Tiếng Việt',
}

/**
 * Get language options with conditional Vietnamese support for staging
 * Vietnamese is inserted alphabetically after Turkish
 */
const getLanguageOptions = (): LanguageOption[] => {
  const isStaging =
    typeof window !== 'undefined' && (window as any).ENVIRONMENT === 'staging'

  if (isStaging) {
    return [...BASE_LANGUAGE_OPTIONS, VIETNAMESE_OPTION]
  }

  return BASE_LANGUAGE_OPTIONS
}

/**
 * Language options for UI components (dropdowns, selects)
 * Includes Vietnamese when window.ENVIRONMENT === 'staging'
 */
export const LANGUAGE_OPTIONS = getLanguageOptions()

/**
 * Supported languages for agent/channel configuration
 * Includes Vietnamese when window.ENVIRONMENT === 'staging'
 */
export const SUPPORTED_LANGUAGES = getLanguageOptions()

/**
 * Get the default language code from window configuration
 * Falls back to 'en-GB' if not configured
 */
export const getDefaultLanguageCode = (): string => {
  return typeof window !== 'undefined' && (window as any).DEFAULT_LOCALE
    ? (window as any).DEFAULT_LOCALE
    : 'en-GB'
}
